(function () {
    var articleTools = {
        init: function () {
            articleTools.control();
        },
        copy: function (str, additionalLink = '') {
            const el = document.createElement('textarea');
            el.id = 'temp_element';
            el.value = document.location.protocol + '//' + document.location.host + additionalLink + str;
            el.setAttribute('readonly', '');
            document.body.appendChild(el);

            /*to work on IOS*/
            let selector = document.querySelector('#temp_element');
            if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                selector.setSelectionRange(0, 999999);
            } else {
                selector.select();
            }

            document.execCommand('copy');
            document.body.removeChild(el);

            // to show alert message that the text is copied, implemented on RMIT
            const copiedEvent = $.Event('link:copied');
            $(document).trigger(copiedEvent, [articleTools]);
            if (copiedEvent.isDefaultPrevented()) {
                return;
            }
        },
        control: function () {
            if ($('figure .figure__image').length === 0) {
                $('.download_Figures').closest('.article-tool').hide();
            }

            const permission = document.querySelectorAll('.article-tool__permissions');
            if (permission.length > 0) {
                permission.forEach(el => {
                    const url = el.getAttribute('href');
                    el.addEventListener('click', () => {
                        window.open(url, 'popup', 'width=750,height=650');
                    });
                });
            }
            const likeLink = document.querySelectorAll('.likeLink');
            if (likeLink.length > 0) {
                likeLink.forEach(el => {
                    const url = el.getAttribute('data-url');
                    el.addEventListener('click', () => {
                        articleTools.copy(url, '/lti');
                    });
                });
            }
        },
    };

    UX.articleTools = articleTools;

    if ($('.article-tools__ctrl').length) {
        UX.articleTools.init();
    }
})();
